import { castToDate } from '@/utils/date.utils'

export default class UserDetails {
  private _birthDate!: Date | null
  private _name!: string | null
  private _surname1!: string | null
  private _surname2!: string | null
  private _gender!: string | null
  private _email!: string | null
  private _prefix!: string | null
  private _phone!: string | null
  private _weight!: number | null
  private _height!: number | null

  constructor(data: any = {}) {
    this.birthDate = data.birthDate || data._birthDate
    this.name = (data.name || data._name)?.toUpperCase()
    this.surname1 = (data.surname1 || data._surname1)?.toUpperCase()
    this.surname2 = (data.surname2 || data._surname2)?.toUpperCase()
    this.gender = data.gender || data._gender
    this.email = data.email || data._email
    this.prefix = data.prefix || data._prefix
    this.phone = data.phone || data._phone
    this.weight = data.weight || data._weight
    this.height = data.height || data._height
  }

  get birthDate(): Date | null {
    return this._birthDate
  }
  set birthDate(value: Date | null | undefined) {
    this._birthDate = castToDate(value ?? null)
  }

  get name(): string | null {
    return this._name
  }
  set name(value: string | null | undefined) {
    this._name = value ?? null
  }

  get surname1(): string | null {
    return this._surname1
  }
  set surname1(value: string | null | undefined) {
    this._surname1 = value ?? null
  }

  get surname2(): string | null {
    return this._surname2
  }
  set surname2(value: string | null | undefined) {
    this._surname2 = value ?? null
  }

  get gender(): string | null {
    return this._gender
  }
  set gender(value: string | null | undefined) {
    this._gender = value ?? null
  }

  get email(): string | null {
    return this._email
  }
  set email(value: string | null | undefined) {
    this._email = value ?? null
  }

  get prefix(): string | null {
    return this._prefix
  }
  set prefix(value: string | null | undefined) {
    this._prefix = value ?? null
  }

  get phone(): string | null {
    return this._phone
  }
  set phone(value: string | null | undefined) {
    this._phone = value ?? null
  }

  get weight(): number | null {
    return this._weight
  }
  set weight(value: number | null | undefined) {
    this._weight = value ?? null
  }

  get height(): number | null {
    return this._height
  }
  set height(value: number | null | undefined) {
    this._height = value ?? null
  }

  getFullName() {
    return `${this.name} ${this.surname1} ${this.surname2 ? this.surname2 : ''}`
  }

  getCompletePhone() {
    return `${this.prefix} ${this.phone}`
  }

  updateAttributes(newAttributes: Partial<UserDetails>) {
    Object.assign(this, newAttributes)
  }
}
